// 站点级全局配置 Context
// 优先从 window.__SITE__ 读取(后端在 index.html 里注入,生产/走 3000 端口时生效)
// 没有注入时(开发模式 3001 webpack dev server)走空占位,fetch 回来再替换
import React, { createContext, useContext, useEffect, useState } from 'react';

const SiteContext = createContext(null);

// site_name 留空:避免首屏显示硬编码兜底值,等真实值回来再渲染
function pickInitial() {
  try {
    if (typeof window !== 'undefined' && window.__SITE__) {
      return {
        site_name:    window.__SITE__.site_name    || '',
        site_tagline: window.__SITE__.site_tagline || '',
        announcement: window.__SITE__.announcement || '',
        public_url:   window.__SITE__.public_url   || '',
        support_enabled: !!window.__SITE__.support_enabled,
        support_content: window.__SITE__.support_content || '',
      };
    }
  } catch {}
  return {
    site_name: '', site_tagline: '', announcement: '', public_url: '',
    support_enabled: false, support_content: '',
  };
}

export const SiteProvider = ({ children }) => {
  const [site, setSite] = useState(pickInitial);

  useEffect(() => {
    fetch('/api/status')
      .then((r) => r.json())
      .then((r) => {
        if (r && r.success && r.data) {
          setSite((prev) => ({ ...prev, ...r.data }));
        }
      })
      .catch(() => { /* 开发模式后端挂了就保持空 */ });
  }, []);

  return <SiteContext.Provider value={{ site }}>{children}</SiteContext.Provider>;
};

// 组件消费时若 site_name 为空字符串,说明还在等后端数据
// 生产模式走 3000 端口:window.__SITE__ 已注入 → 首帧就是真实值
// 开发模式走 3001 webpack dev server:window.__SITE__ 不存在 → 等 fetch(几乎无感)
export const useSite = () => useContext(SiteContext) || { site: { site_name: '', site_tagline: '', announcement: '', public_url: '' } };
